$(document).on('click', '.qa_list', function(){
  $(this).children().eq(1).slideToggle(300);
  $(this).children().eq(0).toggleClass("accordion-no-bar");
  $(this).siblings().find(".question").removeClass("accordion-color");
  $(this).siblings().find(".question i").removeClass("rotate-fa");
  $(this).find(".question").toggleClass("accordion-color");
  $(this).find(".fa").toggleClass("rotate-fa");

  $(".qa_list .answer").not($(this).children().eq(1)).slideUp(300);
});

window.stripePaymentIdHandler = function stripePaymentIdHandler(paymentMethodId) {
  const form = document.getElementById('setup-form');
  const hiddenInput = document.createElement('input');
  hiddenInput.setAttribute('type', 'hidden');
  hiddenInput.setAttribute('name', 'paymentMethodId');
  hiddenInput.setAttribute('value', paymentMethodId);
  form.appendChild(hiddenInput);
  form.submit();
}

window.stripe = function stripe() {
  const stripe = Stripe(STRIPE_KEY);
  const elements = stripe.elements();
  const cardElement = elements.create('card', {hidePostalCode: true});
  cardElement.mount('#card-element');

  const cardButton = document.getElementById('card-button');
  const clientSecret = cardButton.dataset.secret;

  cardButton.addEventListener('click', async (e) => {
    $('#loading03').show()
    e.preventDefault()
    const { setupIntent, error } = await stripe.confirmCardSetup(
      clientSecret, {
        payment_method: {
          card: cardElement,
        }
      }
    );
    if (error) {
      console.log(error);
    } else {
      console.log(setupIntent)
      stripePaymentIdHandler(setupIntent.payment_method);
    }
  });
}

$(function(){
  $(".modal_subscription1").modaal({
    before_open: function() {
      $('#title_subscription').text(PRICEID_1_TITLE);
      $('#subtitle_subscription').text('¥1,380');
      $('#priceid').val(PRICEID_1);
    },
    content_source: '#modal_subscription',
    width: 500,
    background: '#444',
  });
  $(".modal_subscription3").modaal({
    before_open: function() {
      $('#title_subscription').text(PRICEID_3_TITLE);
      $('#subtitle_subscription').text('¥3,600');
      $('#priceid').val(PRICEID_3);
    },
    content_source: '#modal_subscription',
    width: 500,
    background: '#444',
  });
  $(".modal_subscription6").modaal({
    before_open: function() {
      $('#title_subscription').text(PRICEID_6_TITLE);
      $('#subtitle_subscription').text('¥6,480');
      $('#priceid').val(PRICEID_6);
    },
    content_source: '#modal_subscription',
    width: 500,
    background: '#444',
  });
  $(".modal_subscription12").modaal({
    before_open: function() {
      $('#title_subscription').text(PRICEID_12_TITLE);
      $('#subtitle_subscription').text('¥10,560');
      $('#priceid').val(PRICEID_12);
    },
    content_source: '#modal_subscription',
    width: 500,
    background: '#444',
  });
  $(".modal_subscriptionCancel").modaal({
    content_source: '#modal_subscriptionCancel',
    width: 500,
    background: '#444',
  });
});
